import React, { useState } from 'react';

import { Calendar } from '@buildoutinc/blueprint-react/ui/Calendar';
import { Popover } from '@buildoutinc/blueprint-react/ui/Popover';
import { faCalendar, faChevronDown } from '@fortawesome/pro-regular-svg-icons';

import { Button } from 'components/ui/button';
import { startOf } from 'helpers/date_utils';
import { DATE_FORMAT, formatDate } from 'helpers/formatters/date_time_formats';

interface Props {
  buttonLabel: string;
  date: Date;
  disabled: boolean;
  saving: boolean;
  showDate: boolean;
  onDateChange: (date: Date) => void;
  onSubmit: () => void;
}

export default function PanelFooter({
  buttonLabel,
  date,
  disabled,
  saving,
  showDate,
  onDateChange,
  onSubmit,
}: Props) {
  const [calendarOpen, setCalendarOpen] = useState(false);

  // activities cannot have occurred in the future
  const today = startOf(new Date(), 'day');

  return (
    <div className="d-flex justify-content-end align-items-center gap-3">
      {showDate && (
        <Popover open={calendarOpen} onOpenChange={setCalendarOpen}>
          <Popover.Trigger
            render={
              // Outlined with a chevron so it reads as something to click, not a static date
              <Button
                aria-label={`Activity date, ${formatDate(date, DATE_FORMAT)}. Change date`}
                icon={faCalendar}
                iconEnd={faChevronDown}
                size="sm"
                variant="outline"
              >
                {formatDate(date, DATE_FORMAT)}
              </Button>
            }
          />
          <Popover.Content align="end" side="top">
            <Popover.Body>
              <Calendar
                defaultMonth={date}
                disabled={{ after: today }}
                mode="single"
                selected={date}
                onSelect={(selected?: Date) => {
                  if (selected) {
                    onDateChange(selected);
                    setCalendarOpen(false);
                  }
                }}
              />
            </Popover.Body>
          </Popover.Content>
        </Popover>
      )}
      <Button disabled={disabled || saving} onClick={onSubmit}>
        {buttonLabel}
      </Button>
    </div>
  );
}
